import Compressor from 'compressorjs';

export default file =>
    new Promise(
        (resolve, reject) =>
            new Compressor(file, {
                quality: 0.6,
                convertSize: 2621440, // 2.5MB
                convertTypes: ['image/png', 'image/webp'],
                success: result => {
                    resolve(result instanceof Blob ? new File([result], result.name, { type: result.type }) : result);
                },
                error: error => {
                    reject(error);
                },
            }),
    );
